// extracted by mini-css-extract-plugin
export default {"mainContainer":"App_mainContainer__Zrnhn","main":"App_main__nhgh3"};